import { render, staticRenderFns } from "./crearVentana.vue?vue&type=template&id=6e822539&scoped=true"
import script from "./crearVentana.vue?vue&type=script&lang=js"
export * from "./crearVentana.vue?vue&type=script&lang=js"
import style0 from "./crearVentana.vue?vue&type=style&index=0&id=6e822539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e822539",
  null
  
)

export default component.exports